/* Activate account (portal invites & new users) component */

import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { EmailLinkComponent, NavigationLinks } from '../common/navigation';
import * as UserComponents from '../common/user-components';
import ApiEndpoints from '../config/apiendpoints';
import AppConfiguration from '../config/configuration';
import * as ReduxQueries from '../queries';

export interface IActivateLoginProps extends AppComp.IAppComponentProps {
  activationUserDetail?: any;
  userObjId?: any;
  activateUser?: any;
  navigateTo?: any;
}

export interface IActivateLoginState extends AppComp.IAppComponentState {
  formChanges?: any;
}

class ActivateLogin extends AppComp.AppComponent<IActivateLoginProps, IActivateLoginState> {
  public originalFormDataCache = {};

  public constructor(props: IActivateLoginProps) {
    super(props, 'app.activate-login.');

    this.state = {
      formChanges: {},
    };
  }

  public componentDidUpdate() {
    let resetFormData = this.getFormChangesResetRequired();

    if (resetFormData && _.size(this.state.formChanges)) {
      this.setState({ formChanges: {} });
    }
  }

  // handler
  public handleLoginButton(e: any) {
    const token = 'NO-TOKEN';

    const changeData = _.merge(
      {},
      {
        _id: Formatters.getStr(this.props, 'activationUserDetail._id'),
      },
      this.state.formChanges
    );

    // console.log('handleLoginButton changeData', changeData);

    this.props.activateUser(changeData, token, false).then(response => {
      // We can promise-chain on the mutation action to trigger state
      // transitions when it succeeds or fails.

      if (response.status >= 200 && response.status < 300) {
        this.originalFormDataCache = {};
        this.setState({ formChanges: {} });

        this.props.navigateTo(NavigationLinks.userLogin());
      } else {
        // Error during creation...
        this.props.navigateTo(NavigationLinks.userLogin());
      }
    });
  }

  public handleFormInputChange(e: any, x: any) {
    // console.log('handleForminputchange', { e: e, x: x });

    const getChangesResult = this.getFormChanges(e, x);
    // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
    if (getChangesResult.applyChanges) {
      this.setState({
        formChanges: getChangesResult.formChanges
      });
    }
  }

  public getFormChanges(e: any, x: any) {
    let result = {
      applyChanges: false,
      formChanges: {},
      formChangesResult: {},
    };

    let fieldName = '';
    let newValue;

    let formChangesCopy = _.cloneDeep(this.state.formChanges);

    if (_.get(e, 'target.props.name')) {
      // Kendo form element
      if (_.has(e, 'target.combobox')) {
        // combobox
        fieldName = _.get(e, 'target.props.name', '');
        newValue = _.get(e, 'target.value');
      } else {
        // assume textbox
        fieldName = _.get(e, 'target.props.name', '');
        newValue = _.get(e, 'value');
      }
    } else {
      const eventTargetType = _.get(e, 'target.type', '');

      switch (eventTargetType) {
        case 'textarea':
        case 'text':
        case 'email':
        case 'password':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value');
          break;

        case 'kendo-dropdownlist':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value', '');
          break;

        case 'virtualized-select':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(x, 'value');
          break;

        case 'delete-button':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value');
          break;

        default:
          // console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
          break;
      }
    }

    // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

    if (!fieldName) { return result; }

    let applyChange = false;
    let origVal = _.get(this.originalFormDataCache, fieldName);
    let formChangesResult = {};
    if (_.isArray(origVal)) {
      if (_.isArray(newValue)) {
        if (!_.isEqual(origVal, newValue)) {
          _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
          _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
          applyChange = true;
        } else {
          applyChange = false;
        }
      } else {
        if (_.includes(origVal, newValue)) {
          // console.log(`original array already contained val ${newValue} origVal`, origVal);
          applyChange = false;
        } else {
          const formChangesArr = _.get(formChangesCopy, fieldName, []);
          // console.log(`${fieldName} formChangesArr`, formChangesArr);
          if (_.includes(formChangesArr, newValue)) {
            // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
            applyChange = false;
          } else {
            formChangesArr.push(newValue);
            _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
            _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
            applyChange = true;
            // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
          }
        }
      }
    } else {
      // if (String(newValue) !== String(origVal)) {
      // New value
      _.set(formChangesCopy, fieldName, newValue);
      _.set(formChangesResult, fieldName, newValue);
      applyChange = true;
      // } else {
      //     // Same as orig val
      //     if (_.has(formChangesCopy, fieldName)) {
      //         _.unset(formChangesCopy, fieldName);
      //         _.set(formChangesResult, fieldName, newValue);
      //         applyChange = true;
      //     }
      // }
    }

    if (applyChange) {
      result.applyChanges = true;
      result.formChanges = _.cloneDeep(formChangesCopy);
      result.formChangesResult = _.cloneDeep(formChangesResult);
    }

    // console.log(`getFormChanges returns result`, result);

    return result;
  }

  public getFormData(userIn: any) {
    const user = _.merge({}, userIn, this.state.formChanges);

    let result = {
      username: Formatters.getStr(user, 'email'), // Formatters.getStr(user, 'username'),

      password: Formatters.getStr(user, 'password'),
      newPassword: Formatters.getStr(user, 'resetPassword'),
      newPasswordConfirm: Formatters.getStr(user, 'resetPasswordConfirm'),

      passwordChangeRequired: Formatters.getBool(user, 'passwordChangeRequired'),
    };

    return _.merge({}, result, this.state.formChanges);
  }

  public getFormChangesCount() {
    return _.size(this.state.formChanges);
  }

  public getFormChangesResetRequired() {
    let resetFormData = false;
    // Props values
    const pa = Formatters.getStr(this.props, 'userObjId');

    // Cached values
    const ca = Formatters.getStr(this.originalFormDataCache, 'userObjId');

    // Determine if formdata state and cache needs reset due to changing associd or invid
    if (pa && ca) {
      resetFormData = (pa !== ca) ? true : false;
    }

    return resetFormData;
  }

  public renderSectionEnterPassword = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 4 };

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
      handleChange: (n, v) => { this.handleFormInputChange(n, v); },
      className: 'inventory-detail-input-full-width',
    });

    let result = (
      <KendoWrappers.KendoFormSectionTitled title={this.appText('enter-your-password')}>
        <KendoWrappers.KendoDisabledInputHidden
          name="username"
          label={this.appText('username')}
          value={Formatters.getStr(formData, 'username')}
          {...inputPropsFullWidthTextDebounced}
        />

        <KendoWrappers.KendoTextInputDebounced
          name="password"
          label={this.appText('password')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'password')}
          {...inputPropsFullWidthTextDebounced}
        />
      </KendoWrappers.KendoFormSectionTitled>
    );

    return result;
  }

  public isPasswordValid = (formData: any): boolean => {
    const password = Formatters.getStr(formData, 'password');

    return (password && UserComponents.IsPasswordValid(password)) ? true : false;
  }

  public isNewPasswordValid = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');

    return (newPassword && UserComponents.IsPasswordValid(newPassword)) ? true : false;
  }

  public hasNewPasswordOrConfirmPassword = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');
    const newPasswordConfirm = Formatters.getStr(formData, 'newPasswordConfirm');

    return (newPassword || newPasswordConfirm) ? true : false;
  }

  public isNewPasswordConfirmValid = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');
    const newPasswordConfirm = Formatters.getStr(formData, 'newPasswordConfirm');

    return ((newPassword && newPasswordConfirm) && UserComponents.DoPasswordsMatch(newPassword, newPasswordConfirm)) ? true : false;
  }

  public renderNewPasswordValidation = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 6 };
    const isValid = this.isNewPasswordValid(formData);
    const hasPasswords = this.hasNewPasswordOrConfirmPassword(formData);

    const result = (hasPasswords && !isValid) ? (
      <KendoWrappers.ValidationErrorMessage defaultInputProps={defaultInputProps}>
        <span>{this.appTextCommon('forms.validation.password-min-length', 'app.common.', false, String(UserComponents.MinimumPasswordLength))}</span>
      </KendoWrappers.ValidationErrorMessage>
    ) : (<div />);

    return result;
  }

  public renderNewPasswordConfirmValidation = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 6 };
    const isValid = this.isNewPasswordConfirmValid(formData);
    const hasPasswords = this.hasNewPasswordOrConfirmPassword(formData);

    const result = (hasPasswords && !isValid) ? (
      <KendoWrappers.ValidationErrorMessage defaultInputProps={defaultInputProps}>
        <span>{this.appTextCommon('forms.validation.passwords-mismatched')}</span>
      </KendoWrappers.ValidationErrorMessage>
    ) : (<div />);

    return result;
  }

  public renderSectionChangePassword = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 4 };

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
      handleChange: (n, v) => { this.handleFormInputChange(n, v); },
      className: 'inventory-detail-input-full-width',
    });

    let result = (
      <KendoWrappers.KendoFormSectionTitled title={this.appText('create-new-password')}>
        <KendoWrappers.KendoTextInputDebounced
          name="newPassword"
          label={this.appText('new-password')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'newPassword')}
          {...inputPropsFullWidthTextDebounced}
        />

        {this.renderNewPasswordValidation(formData)}

        <KendoWrappers.KendoTextInputDebounced
          name="newPasswordConfirm"
          label={this.appText('new-password-confirm')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'newPasswordConfirm')}
          {...inputPropsFullWidthTextDebounced}
        />

        {this.renderNewPasswordConfirmValidation(formData)}
      </KendoWrappers.KendoFormSectionTitled>
    );

    return result;
  }

  public renderSupportEmailLink = (hideIcon: boolean = true) => {
    const supportEmail = AppConfiguration.getSupportEmail();

    return (supportEmail) ? (
      <EmailLinkComponent
        email={supportEmail}
        hideIcon={hideIcon}
        caption={`${this.appTextCommon('contacts.send-email-to')} ${supportEmail}`}
      />) : undefined;
  }

  public render() {
    const { userObjId, activationUserDetail: user, ...rest } = this.props;

    let page = (<div />);

    if (Formatters.getStr(user, '_id') !== userObjId) { return page; }

    const formData = this.getFormData(user);

    if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
      this.originalFormDataCache = _.cloneDeep(formData);
    }

    const showChangePassword = Formatters.getBool(formData, 'passwordChangeRequired');
    const sectionChangePassword = (showChangePassword) ? (
      <div className="activate-form-section">
        {this.renderSectionChangePassword(formData)}
      </div>) : (<div />);

    const passwordValid = this.isPasswordValid(formData);
    const newPasswordValid = (showChangePassword) ? this.isNewPasswordValid(formData) : true;
    const newPasswordsMatch = (showChangePassword) ? this.isNewPasswordConfirmValid(formData) : true;
    const isFormValid = (passwordValid && newPasswordValid && newPasswordsMatch) ? true : false;

    let activateLoginInstructions = `${this.appText('activate-instructions-1')} ${this.appText('activate-instructions-2')} `;
    if (showChangePassword) { activateLoginInstructions += `${this.appText('activate-instructions-2-change-password')} `; }
    activateLoginInstructions += `${this.appText('activate-instructions-3')} `;

    page = (
      <Well className="activate-login-well">
        <Row className="activate-login-panel">
          <Col xs={12}>
            <div className="activate-login-header">
              <h1>{this.appText('activate-your-account')}</h1>
            </div>

            <div className="activate-login-text">
              <p>{activateLoginInstructions} {this.renderSupportEmailLink()}.</p>
            </div>

            <div>
              <div className="activate-form-section">
                {this.renderSectionEnterPassword(formData)}
              </div>

              {sectionChangePassword}
            </div>

            <div className="activate-login-button-container">
              <Row>
                <Col xs={2} />
                <Col xs={8}>
                  <Button
                    bsSize="large"
                    bsStyle="success"
                    disabled={!isFormValid}
                    block={true}
                    onClick={e => { this.handleLoginButton(e); }}
                  >
                    {this.appText('activate-account')}
                  </Button>
                </Col>
                <Col xs={2} />
              </Row>
            </div>
          </Col>
        </Row>
      </Well>
    );

    return page;
  }
}

const getApiUrl = props => ApiEndpoints.getUserActivationUrl(Formatters.getStr(props, 'match.params.userObjId'));

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getUserActivationRequest(
  getApiUrl(props),
  'NO-TOKEN',
);

const mapStateToProps = (state, props) => {
  const userObjId = Formatters.getStr(props, 'match.params.userObjId');

  return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
    activationUserDetail: state.entities.activationUser,
    userObjId: userObjId,
  });
};

const mapDispatchToProps = {
  activateUser: MutateActions.activateUserMutateAsync,
  navigateTo: (path) => push(path),
};

const ActivateLoginContainer = compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfigs)
)(ActivateLogin);

export default withRouter(ActivateLoginContainer);



// WEBPACK FOOTER //
// ./src/activate-account/activate-login.tsx